var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.PageStore.isLogin())?_vm._t("default"):_vm._t("not",function(){return [_c('div',{staticClass:"xt-text-center"},[_c('a-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.PageStore.onToggleVisible(true)}}},[_vm._v("请登录")])],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }